module.exports = __webpack_public_path__ + "img/part2-icon1.13f655cb.png";